import { IPaymentMethodFormType } from "@nju/data-access-portal-payment";
import { Radio, RadioGroup } from "@nju/form";
import { Icon } from "@nju/icons";
import { Text } from "@nju/ui";

interface IPaymentVariantsProps {
  handleSetValue: (value: IPaymentMethodFormType) => void;
}

export function PaymentVariants({ handleSetValue }: IPaymentVariantsProps) {
  return (
    <RadioGroup
      aria-label="Metoda płatności"
      name="methodType"
      onValueChange={(value) => {
        handleSetValue(value as IPaymentMethodFormType);
      }}
    >
      <>
        <Radio data-cy="credit-card-option" value="CREDIT_CARD">
          <Text>karta płatnicza</Text>
          <div className="ml-3 flex items-center">
            <Icon height={24} name="credit-card" tone="accent" width={27} />
          </div>
        </Radio>

        <Radio value="DIGITAL_WALLET">
          <Text>BLIK</Text>
          <div className="ml-3 flex items-center">
            <img alt="blik" height={17} src="/images/blik.svg" width={32} />
          </div>
        </Radio>

        <Radio value="PAY_BY_LINK">
          <Text>płatność online</Text>
          <div className="ml-3 flex items-center">
            <Icon height={24} name="university" tone="accent" width={24} />
          </div>
        </Radio>
      </>
    </RadioGroup>
  );
}
